/* eslint-disable react/no-unknown-property */
import { Sketch } from "@uiw/react-color";
import { Checkbox, DatePicker, Modal, Select, Tag } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useState, useRef, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import styled from "styled-components";

import { ReactComponent as ICON_ARROW } from "@assets/svgs/ICON_ARROW.svg";
import { ReactComponent as ICON_CLOSE_COLOR } from "@assets/svgs/ICON_CLOSE_COLOR.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TRANSPARENT } from "@assets/svgs/ICON_TRANSPARENT.svg";
import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import {
  COLOR_DARK,
  COLOR_GREEN,
  COLOR_GREY,
  COLOR_GREY_1,
  COLOR_RED,
  COLOR_WHITE,
} from "@static/COLORS";
import { DEFAULT_DURATION } from "@static/DEFAULT_DURATION";
import { onHandleDeleteBlockMedia } from "@utils/mediaBlockEditor/onHandleDeleteBlockMedia";
import {
  onHandleDurationBlur,
  onHandleDurationChange,
} from "@utils/mediaBlockEditor/onhandleInputDuration";
import {
  onHandleRepeatBlur,
  onHandleRepeatChange,
} from "@utils/mediaBlockEditor/onhandleInputRepeat";
import { onHandleSwapBlockMediaIndex } from "@utils/mediaBlockEditor/onHandleSwapBlockMediaIndex";
import { VALIDATE_RULES } from "@validate/index";
const { RangePicker } = DatePicker;

const Container = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;
  border: 1px solid ${({ borderColor = COLOR_GREY_1 }) => borderColor};
  border-radius: 8px;
  display: flex;
  padding: 16px;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
`;

const SectionContents = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

const MargueeContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ backgroundColor }) => backgroundColor};
`;

const ContainerName = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const SectionAction = styled.div`
  display: flex;
  gap: 8px;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
`;

const ContainerField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const ContainerControlActionOne = styled.div`
  display: grid;
  grid-template-columns: 10% 10% 10% 20% auto 10%;
  gap: 8px;
`;

const ContainerControlActionTwo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 50px;
  gap: 8px;
`;

const ContainerControlAction = styled.div`
  width: 100%;
  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
`;

const ShowExpireContainer = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
`;

const GroupInput = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GroupActionInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;
`;

const FONT_SIZE_LIST = [
  { label: "16px", value: "16px" },
  { label: "20px", value: "20px" },
  { label: "24px", value: "24px" },
  { label: "32px", value: "32px" },
  { label: "64px", value: "64px" },
  { label: "128px", value: "128px" },
];

const FONT_FAMILY_LIST = [
  { label: "Anuphan", value: "Anuphan" },
  { label: "Athiti", value: "Athiti" },
  { label: "BaiJamjuree", value: "BaiJamjuree" },
  { label: "ChakraPetch", value: "ChakraPetch" },
  { label: "Charm", value: "Charm" },
  { label: "Charmonman", value: "Charmonman" },
  { label: "Chonburi", value: "Chonburi" },
  { label: "IBMPlexSansThai", value: "IBM Plex Sans Thai" },
  { label: "Itim", value: "Itim" },
  { label: "K2D", value: "K2D" },
  { label: "Kanit", value: "Kanit" },
  { label: "Kodchasan", value: "Kodchasan" },
  { label: "Krub", value: "Krub" },
  { label: "Maitree", value: "Maitree" },
  { label: "Mali", value: "Mali" },
  { label: "NotoSansThaiLooped", value: "NotoSansThaiLooped" },
  { label: "Pattaya", value: "Pattaya" },
  { label: "Sarabun", value: "Sarabun" },
  { label: "Sriracha", value: "Sriracha" },
  { label: "Srisakdi", value: "Srisakdi" },
  { label: "KoHo", value: "KoHo" },
  { label: "Niramit", value: "Niramit" },
  { label: "Fahkwang", value: "Fahkwang" },
];

const DIRECTION_LIST = [
  { label: "Right to left", value: "left" },
  { label: "Left to right", value: "right" },
];

const MarqueeText = styled.div`
  color: ${({ color = "white" }) => color};
  font-size: ${({ fontSize = "16px" }) => fontSize};
  font-family: ${({ fontFamily = "IBM Plex Sans Thai" }) => fontFamily};
  white-space: nowrap;
`;

const TransparentButton = styled.button`
  /* position: absolute; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* top: 30px;
  right: 20px; */
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: ${({ isTransparent }) => (isTransparent ? "block" : "none")};
  pointer-events: ${({ isTransparent }) => (isTransparent ? "auto" : "none")};
`;

const ContainerColorFrame = styled.button`
  position: relative;
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 5px;
  padding: 0px;
  border: 1px solid #d9d9d9;
  background: transparent;
`;

const ColorRectangle = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-right: 5px;
  background: ${({ color }) => color};
  border-radius: 3;
  border: 1px solid ${COLOR_GREY_1};
`;

const ContainerColorPickerMainWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 40000;
`;

const ContainerColorPickerWrapper = styled.div`
  width: 375px;
  padding: 20px;
  border-radius: 12px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const ContainerCloseColorPickerMain = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

export const EditorRunningText = ({
  item,
  index,
  blockMediaList = [],
  setBlockMediaList = () => undefined,
  isActive,
  setActiveIndex = () => undefined,
}) => {
  console.log("item :>> ", item);
  const initialIsNoEnd = dayjs(_.get(item, ["end_date"])).isSame(
    "3000-01-01",
    "day"
  );
  const [isNoEnd, setIsNoEnd] = useState(initialIsNoEnd);
  const [repeat, setRepeat] = useState(_.get(item, ["repeat"], 1));
  // console.log("color :>> ", color);

  const [isOpenPickerColor, setIsOpenPickerColor] = useState({
    isOpen: false,
    pickerColorType: null,
  });

  const { watch, control, handleSubmit } = useForm({
    defaultValues: {
      dateRange: [
        dayjs(_.get(item, ["start_date"])),
        dayjs(_.get(item, ["end_date"])),
      ],
    },
  });
  const text = _.get(item, ["attribute", "text"]);
  const fontSize = _.get(item, ["attribute", "fontSize"]);
  const direction = _.get(item, ["attribute", "direction"]);
  const color = _.get(item, ["attribute", "color"]);

  const isFreeze = _.get(item, ["attribute", "isFreeze"], false);

  const speed = _.get(item, ["attribute", "speed"], 10);
  const fontFamily = _.get(item, ["attribute", "fontFamily"]);
  const backgroundColor = _.get(item, ["attribute", "backgroundColor"]);
  const [isTransparent, setIsTransparent] = useState(
    backgroundColor === "transparent"
  );

  const [selectedColor, setSelectedColor] = useState(null);

  const defaultFontSize = _.find(FONT_SIZE_LIST, (fontSizeItem) => {
    return fontSize === _.get(fontSizeItem, ["value"]);
  });

  const defaultFontFamily = _.find(FONT_FAMILY_LIST, (fontFamilyItem) => {
    return fontFamily === _.get(fontFamilyItem, ["value"]);
  });

  const defaultDirection = _.find(DIRECTION_LIST, (directionItem) => {
    return direction === _.get(directionItem, ["value"]);
  });

  const [duration, setDuration] = useState(
    _.get(item, ["duration"], DEFAULT_DURATION)
  );

  const [speedText, setSpeedText] = useState(speed);

  const inputRef = useRef(null);

  useEffect(() => {
    if (isActive && inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
    }
  }, [isActive]);

  const onHandleChangeValue = ({ key, value }) => {
    const updatedItem = _.set({ ...item }, key, value);
    setBlockMediaList((prevList) => {
      const newList = [...prevList];
      newList[index] = updatedItem;
      return newList;
    });
  };

  const onHandleSpeedChange = ({ event }) => {
    const value = _.chain(event).get(["target", "value"]).toInteger().value();
    setSpeedText(value);
  };

  const onHandleSpeedBlur = ({ event }) => {
    const value = _.chain(event).get(["target", "value"]).toInteger().value();
    if (value <= 0 || _.isNaN(value)) {
      setSpeedText(10);
      onHandleChangeValue({ key: ["attribute", "speed"], value: 10 });
    } else {
      onHandleChangeValue({ key: ["attribute", "speed"], value });
    }
  };

  const onTextInputChange = (e) => {
    onHandleChangeValue({
      key: ["attribute", "text"],
      value: e?.target?.value,
    });
  };

  const onHandleChangeDateRange = (value) => {
    const date_range_start_raw = _.get(value, [0]);
    const date_range_end_raw = _.get(value, [1]);

    const start_date = dayjs(date_range_start_raw).format("YYYY-MM-DD");
    const end_date = dayjs(date_range_end_raw).format("YYYY-MM-DD");
    const updatedItem = {
      ...item,
      start_date,
      end_date,
    };
    setBlockMediaList((prevList) => {
      const newList = [...prevList];
      newList[index] = updatedItem;
      return newList;
    });
  };
  const dateRange = watch("dateRange");
  const currentDate = dayjs();
  const endDate = _.get(dateRange, [1]);
  const isExpired = currentDate.isAfter(endDate);
  const expiredDays = isExpired ? currentDate.diff(endDate, "day") : 0;

  const onHandleNoEndChange = (checked) => {
    setIsNoEnd(checked);
    const start_date = checked
      ? dayjs("1990-01-01").format("YYYY-MM-DD")
      : dayjs().subtract(1, "day").format("YYYY-MM-DD");
    const end_date = checked
      ? dayjs("3000-01-01").format("YYYY-MM-DD")
      : dayjs().add(1, "month").format("YYYY-MM-DD");
    const updatedItem = {
      ...item,
      start_date,
      end_date,
    };
    setBlockMediaList((prevList) => {
      const newList = [...prevList];
      newList[index] = updatedItem;
      return newList;
    });
  };

  const onHandleFreezeChange = (value) => {
    console.log("value :>> ", value);
    onHandleChangeValue({
      key: ["attribute", "isFreeze"],
      value: value,
    });
  };

  const handleTransparentClick = () => {
    const updateIsTransparent = !isTransparent;
    setIsTransparent(updateIsTransparent);

    onHandleChangeValue({
      key: ["attribute", "backgroundColor"],
      value: updateIsTransparent ? "transparent" : "black",
    });
  };

  const onHandleConfirm = () => {
    if (_.get(isOpenPickerColor, ["pickerColorType"]) === "font-color") {
      console.log("font-color selectedColor :>> ", selectedColor);
      onHandleChangeValue({
        key: ["attribute", "color"],
        value: selectedColor,
      });
    } else {
      console.log("background-color selectedColor :>> ", selectedColor);
      onHandleChangeValue({
        key: ["attribute", "backgroundColor"],
        value: selectedColor,
      });
    }
  };

  return (
    <Container
      borderColor={isExpired ? COLOR_RED : COLOR_GREY}
      onClick={() => setActiveIndex(index)}
    >
      <SectionContents>
        <MargueeContainer backgroundColor={backgroundColor}>
          {isFreeze ? (
            <MarqueeText
              color={color}
              fontSize={fontSize}
              fontFamily={fontFamily}
            >
              {text}
            </MarqueeText>
          ) : (
            <marquee direction={direction} scrollamount={speed}>
              <MarqueeText
                color={color}
                fontSize={fontSize}
                fontFamily={fontFamily}
              >
                {text}
              </MarqueeText>
            </marquee>
          )}
        </MargueeContainer>
        <InputContainer>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <ContainerName>
              <div
                style={{
                  display: "grid",
                  width: "100%",
                  gridTemplateColumns: "1fr 10%",
                  gap: 8,
                }}
              >
                <ContainerField>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                      {_.startCase("Text")}
                    </Text>
                    {isExpired && (
                      <Text
                        style={{ width: "auto" }}
                        align="center"
                        color="#F41C0C"
                        fontSize={"14px"}
                        fontWeight="600"
                      >
                        {`Expired ( ${expiredDays} days )`}
                      </Text>
                    )}
                  </div>
                  <StyledInput
                    placeholder="Enter text"
                    value={text}
                    ref={inputRef}
                    onChange={onTextInputChange}
                  />
                </ContainerField>
                <CheckboxContainer>
                  <Text color={COLOR_DARK} fontSize="14px">
                    Freeze
                  </Text>
                  <Checkbox
                    style={{ marginTop: 10 }}
                    checked={isFreeze}
                    onChange={(e) => onHandleFreezeChange(e.target.checked)}
                  />
                </CheckboxContainer>
              </div>
            </ContainerName>
            <ContainerControlActionOne>
              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("duration")}
                </Text>
                <StyledInput
                  value={duration}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) =>
                    onHandleDurationChange({ event: e, setDuration })
                  }
                  onBlur={(e) =>
                    onHandleDurationBlur({
                      event: e,
                      setDuration,
                      onHandleChangeValue,
                    })
                  }
                />
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Speed")}
                </Text>
                <StyledInput
                  value={speedText}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) => onHandleSpeedChange({ event: e })}
                  onBlur={(e) =>
                    onHandleSpeedBlur({
                      event: e,
                    })
                  }
                />
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Repeat")}
                </Text>
                <StyledInput
                  value={repeat}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) =>
                    // onHandleDurationChange({ event: e, setRepeat })
                    onHandleRepeatChange({ event: e, setRepeat })
                  }
                  onBlur={(e) =>
                    onHandleRepeatBlur({
                      event: e,
                      setRepeat,
                      onHandleChangeValue,
                    })
                  }
                />
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Direction")}
                </Text>
                <Select
                  showSearch
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  options={DIRECTION_LIST}
                  defaultValue={defaultDirection}
                  onChange={(value) => {
                    onHandleChangeValue({
                      key: ["attribute", "direction"],
                      value,
                    });
                  }}
                />
              </ContainerField>

              <ContainerField>
                <Controller
                  name="dateRange"
                  control={control}
                  rules={_.get(VALIDATE_RULES, ["required"])}
                  render={({ field, fieldState: { error } }) => (
                    <div>
                      <Text
                        color={COLOR_DARK}
                        fontWeight="400"
                        fontSize="14px"
                        style={{ marginBottom: 4 }}
                      >
                        Date Range
                      </Text>
                      <RangePicker
                        {...field}
                        disabled={isNoEnd}
                        className={isNoEnd && "picker-no-limit"}
                        style={{ width: "100%" }}
                        allowClear={false}
                        onChange={(value) => {
                          field.onChange(value);
                          onHandleChangeDateRange(value);
                        }}
                      />
                    </div>
                  )}
                />
              </ContainerField>
              <CheckboxContainer>
                <Text color={COLOR_DARK} fontSize="14px">
                  Forever
                </Text>
                <Checkbox
                  style={{ marginTop: 10 }}
                  checked={isNoEnd}
                  onChange={(e) => onHandleNoEndChange(e.target.checked)}
                />
              </CheckboxContainer>
            </ContainerControlActionOne>
            <ContainerControlActionTwo>
              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Font Size")}
                </Text>
                <Select
                  showSearch
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  options={FONT_SIZE_LIST}
                  defaultValue={defaultFontSize}
                  onChange={(value) => {
                    onHandleChangeValue({
                      key: ["attribute", "fontSize"],
                      value,
                    });
                  }}
                />
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Font Family")}
                </Text>
                <Select
                  showSearch
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  options={FONT_FAMILY_LIST}
                  defaultValue={defaultFontFamily}
                  onChange={(value) => {
                    onHandleChangeValue({
                      key: ["attribute", "fontFamily"],
                      value,
                    });
                  }}
                />
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Font Color")}
                </Text>
                <ContainerColorFrame
                  onClick={() => {
                    setSelectedColor(color);
                    setIsOpenPickerColor({
                      isOpen: true,
                      pickerColorType: "font-color",
                    });
                  }}
                >
                  <ColorRectangle color={color} />
                  <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                    {color}
                  </Text>
                </ContainerColorFrame>
              </ContainerField>

              <ContainerField>
                <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                  {_.startCase("Background Color")}
                </Text>
                <ContainerColorFrame
                  onClick={() => {
                    setSelectedColor(backgroundColor);
                    setIsOpenPickerColor({
                      isOpen: true,
                      pickerColorType: "background-color",
                    });
                  }}
                >
                  <ColorRectangle color={backgroundColor} />
                  <Text color={COLOR_DARK} fontWeight="400" fontSize="14px">
                    {backgroundColor}
                  </Text>
                </ContainerColorFrame>
              </ContainerField>
              <div>
                <Text
                  color={COLOR_DARK}
                  fontWeight="400"
                  fontSize="14px"
                  style={{ marginBottom: 4 }}
                >
                  {" "}
                </Text>
                <TransparentButton onClick={() => handleTransparentClick()}>
                  <ICON_TRANSPARENT />
                </TransparentButton>
              </div>
            </ContainerControlActionTwo>
          </div>

          <SectionAction>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Icon
                disabled={index === 0}
                isCursor
                width={24}
                height={24}
                isRotated
                onClick={() =>
                  onHandleSwapBlockMediaIndex({
                    type: "up",
                    index,
                    setBlockMediaList,
                  })
                }
              >
                <ICON_ARROW />
              </Icon>
              <Icon
                disabled={index === _.size(blockMediaList) - 1}
                isCursor
                width={24}
                height={24}
                onClick={() =>
                  onHandleSwapBlockMediaIndex({
                    type: "down",
                    index,
                    setBlockMediaList,
                  })
                }
              >
                <ICON_ARROW />
              </Icon>
            </div>

            <Icon
              isCursor
              width={24}
              height={24}
              onClick={() =>
                onHandleDeleteBlockMedia({
                  index,
                  blockMediaList,
                  setBlockMediaList,
                })
              }
            >
              <ICON_TABLE_DELETE />
            </Icon>
          </SectionAction>
        </InputContainer>
      </SectionContents>
      {_.get(isOpenPickerColor, ["isOpen"]) && (
        <ContainerColorPickerMainWrapper>
          <ContainerColorPickerWrapper>
            <ContainerCloseColorPickerMain>
              <Icon
                isCursor
                width={10}
                height={10}
                onClick={() => {
                  setSelectedColor(null);
                  setIsOpenPickerColor({
                    isOpen: false,
                    pickerColorType: null,
                  });
                }}
              >
                <ICON_CLOSE_COLOR />
              </Icon>
            </ContainerCloseColorPickerMain>
            <Sketch
              disableAlpha={true}
              color={color}
              onChange={(color) => {
                // onHandleChangeValue({
                //   key: ["attribute", "color"],
                //   value: color?.hex,
                // });
                setSelectedColor(color?.hex);
              }}
            />
            <Button
              onClick={() => onHandleConfirm()}
              color={COLOR_GREEN}
              fontColor={COLOR_WHITE}
              fontSize="16px"
              padding="5px 20px"
            >
              Confirm
            </Button>
          </ContainerColorPickerWrapper>
        </ContainerColorPickerMainWrapper>
      )}
    </Container>
  );
};
